module.exports = __webpack_public_path__ + "6ba2f427c1146906748447076ac5d71a.svg";